// tslint:disable:file-name-casing
// Justification: File is used only as an entry point, and the compiled file
// should match the existing naming scheme.

// Polyfills for targeted browsers.  Babel will read this import and examine
// the .browserslistrc file to determine what browsers we are supporting, then
// include only the polyfills that are needed.
import "core-js";

// Async/await support for IE11. : Leaving this in as it seems something(?) is requiring it.
import "regenerator-runtime";

// we need to polyfill until we have all script usage compiled?
import "./extensions/HtmlCollection.prototype.forEach";

// Element.prototype.remove support for IE11.
// import "./extensions/Element.prototype.remove";

// import "./extensions/Element.prototype.closest";

// Fetch support for IE11
// Depends on Promise support for IE11, currently provided by core-js.
// import "whatwg-fetch";

// export * from "./components/newsArticle/NewsArticleAds";
export * from "./components/genericLanding/LandingCardLayout";
export * from "./components/genericLanding/LandingCardLoader";
export * from "./components/genericLanding/MasonryReflow";
export * from "./components/genericLanding/LandingNoMasonry";
export * from "./components/healioGlobal/HealioSearchBox";
export * from "./components/healioGlobal/EmailSignUp";
export * from "./components/healioGlobal/EmailSignUpSuccessModal";
export * from "./components/healioGlobal/HealioErrorModal";
export * from "./components/healioGlobal/HealioHeader";
export * from "./components/healioGlobal/ScrollToTopButton";
export * from "./components/healioGlobal/SpecialtySelect";
export * from "./components/healioGlobal/SubSpecialtySelect";
export * from "./components/healioGlobal/ListUnstyled";
export * from "./components/healioGlobal/LoginSignupSplash";
export * from "./components/healioGlobal/SearchHistory";
export * from "./components/homepage/HomeSpecialtySelect";
export * from "./components/mySavedPages/MySavedPages";
export * from "./components/news/SiteMapSpecialtyFilter";
export * from "./components/news/NewsHeaderLinks";
export * from "./components/news/NewsLandingRedirect";
export * from "./components/news/Podcast2026SeriesEpisodes";
export * from "./components/news/ViewBySpecialty";
export * from "./components/news/ViewBySubSpecialty";
export * from "./components/newsArticle/EmailTopicAlert";
export * from "./components/newsArticle/ReadNext";
export * from "./components/newsArticle/ReadNextContentDiscoverability";
export * from "./components/newsArticle/ListenNextContentDiscoverability";
export * from "./components/newsArticle/PodcastYouMayAlsoLikeDiscoverability";
export * from "./components/newsArticle/PodcastSavedYouMayAlsoLikeDiscoverability";
export * from "./components/newsArticle/RelatedContent";
export * from "./components/newsArticle/WindowLoadEventTracker";
export * from "./components/newsArticle/NextArticle";
export * from "./components/newsArticle/ArticleContent";
export * from "./components/newslanding/HealioMinuteSignUp";
export * from "./components/newslanding/MeetingCalendarFilter";
export * from "./components/newslanding/SpecialtyLandingFeatured";
export * from "./components/newslanding/YearFilter";
export * from "./components/newslanding/PinnedSeries";
export * from "./components/newslanding/PodcastSavedTabLoader";
export * from "./components/newsPublication/PublicationDateSelect";
export * from "./components/newsPublication/PublicationSubscription";
export * from "./components/recommendations/CmeActivityRecoCards";
export * from "./components/SaveIcon";
export * from "./components/healioGlobal/AjaxCustomComponentLoader"
export * from "./util/EventUtil";
export * from "./util/LocalStorageUtil";
export * from "./components/myCme/CMEGoalNotifications";

export { context } from "./Wyanoke/WyanokeContext";
export { moduletracking } from "./Wyanoke/ModuleTracking";